// @flow

import reducer from './reducer';

export {
  processConfiguration,
  resetConfiguration,
} from './actions';

export {
  SUCCESS_STORING_CONFIGURATION,
  REQUEST_STORING_CONFIGURATION,
  FAILURE_STORING_CONFIGURATION,
  RETRY_STORING_CONFIGURATION,
} from './constants';

export {
  isLoading,
  hasError,
  hasSaved,
  getErrorResponse,
  getLoginHash,
} from './selectors';

export default reducer;
